import PropTypes from 'prop-types';
import GetIcon from '../../utils/Icon';

const CardTable = ({
    data,
    loading,
    onRowClick,
    className = '',
    emptyMessage = 'No data available',
    loadingMessage = 'Loading...',
}) => {
    const rows = Array.isArray(data) ? data : [];

    return (
        <div className={`p-3 ${className}`}>
            {loading ? (
                <div className="text-center py-5">{loadingMessage}</div>
            ) : rows.length === 0 ? (
                <div className="text-center py-5">{emptyMessage}</div>
            ) : (
                <div className="container-fluid">
                    <div className="row g-3">
                        {rows.map((row, rowIndex) => (
                            <div key={rowIndex} className="col-12 col-sm-6 col-md-4 col-lg-3">
                                <div
                                    className="card shadow-sm border rounded-4 p-2"
                                    onClick={() => onRowClick && onRowClick(row)}
                                    style={{ cursor: onRowClick ? 'pointer' : 'default', height: '100px' }}
                                >
                                    <div className="d-flex align-items-start">
                                        {/* Image */}
                                        <div
                                            style={{
                                                background: '#f5f5f5',
                                                borderRadius: '8px',
                                                padding: '4px',
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                width: '100px',
                                                height: '80px',
                                                flexShrink: 0,
                                            }}
                                        >
                                            <img
                                                src={
                                                    row.image
                                                        ? `${process.env.REACT_APP_API_URL}/${row.image}`
                                                        : 'https://kinclimg4.bluestone.com/f_jpg,c_scale,w_1024,q_80,b_rgb:f0f0f0/giproduct/BISM0014N08_YAA18DIG6XXXXXXXX_ABCD00-PICS-00000-1024-33606.png'
                                                }
                                                alt="Item"
                                                className="rounded"
                                                style={{
                                                    width: '70px',
                                                    height: '100%',
                                                    objectFit: 'contain',
                                                    borderRadius: '6px',
                                                }}
                                            />
                                        </div>

                                        {/* Info */}
                                        <div className="ms-2 flex-grow-1">
                                            <p className="text-muted mb-1 small" style={{ fontSize: '0.7rem' }}>
                                                {row.item_name || '—'}
                                            </p>
                                            <p className="text-muted mb-1 small" style={{ fontSize: '0.7rem' }}>
                                                {row.item_group || '—'}
                                            </p>
                                            <p className="text-muted mb-1 small" style={{ fontSize: '0.7rem' }}>
                                                {row.creation || '—'}
                                            </p>
                                            <p
                                                className="text-muted mb-1 small"
                                                style={{
                                                    fontSize: '0.7rem',
                                                    color: row.disabled === 1 ? '#D97706' : '#6366F1',
                                                }}
                                            >
                                                {row.disabled === 1 ? 'Disabled' : 'Enabled'}
                                            </p>
                                        </div>

                                        {/* Actions */}
                                        <div
                                            className="d-flex flex-column align-items-center justify-content-center ms-1"
                                            style={{ gap: '6px' }}
                                        >
                                            <GetIcon iconName="CiHeart" size={14} color="#6c757d" />
                                            <GetIcon iconName="MdOutlineRemoveRedEye" size={14} color="#4b002b" />
                                            <GetIcon iconName="BiEditAlt" size={14} color="#4b002b" />
                                            <GetIcon iconName="MdDeleteOutline" size={14} color="#4b002b" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            )}
        </div>
    );
};

CardTable.propTypes = {
    data: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
    loading: PropTypes.bool,
    onRowClick: PropTypes.func,
    className: PropTypes.string,
    emptyMessage: PropTypes.string,
    loadingMessage: PropTypes.string,
};

CardTable.defaultProps = {
    loading: false,
};

export default CardTable;
